import React from "react";
import "flatpickr/dist/themes/airbnb.css";
import MomentUtils from "@date-io/moment";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider
} from "@material-ui/pickers";
import classNames from "classnames";

import { noop } from "utils/General";
import { DATE_FORMAT_MATERIAL } from "../../constants";
import { Text1 } from "components/Base";
import css from "../DateTimeInput/styles.scss";

export const DateTimeInputWithoutSagas = ({
  onChange = noop,
  value = "",
  minDate = null,
  maxDate = null,
  "data-cy": dataCy,
  modalVariant = false,
  useHelperText = false,
  style = {},
  disabled = false,
  useErrorState = true
}) => {
  const muiClasses = classNames(css.keyboardDateTimeInput, {
    [css.modalvariant]: modalVariant
  });

  const extraProps = {};
  if (useErrorState === false) {
    extraProps.error = null;
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDateTimePicker
        onOpen={() => {
          setTimeout(() => {
            const actionsRoot = document.getElementsByClassName(
              "MuiDialogActions-root"
            )[0];
            const buttons = actionsRoot.querySelectorAll("button");
            actionsRoot.insertBefore(buttons[1], buttons[0]);
          }, 100);
        }}
        className={muiClasses}
        DialogProps={{ className: css.dialog }}
        value={value}
        minDate={minDate ? minDate : undefined}
        maxDate={maxDate ? maxDate : undefined}
        allowKeyboardControl
        inputVariant="outlined"
        format={DATE_FORMAT_MATERIAL}
        helperText={useHelperText ? "" : DATE_FORMAT_MATERIAL}
        onChange={onChange}
        data-cy={dataCy}
        style={style}
        disabled={disabled}
        {...extraProps}
      />
      {useHelperText && (
        <Text1 ml={3} mb={1} color="gray6">
          {DATE_FORMAT_MATERIAL}
        </Text1>
      )}
    </MuiPickersUtilsProvider>
  );
};
